export default __webpack_public_path__ + "static/media/closet5-before1-1440w.04341441.avif";